import React, { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable';
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import SKAlerts, { CreateAlert } from '../common-alerts/SKAlerts';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function TitleDropdown({ onChangeDropdown, modelName, required, placeholder, selectedValue, isDisable }) {
    const [selectedTitleOption, setSelectedTitleOption] = useState([]);
    const [getTitleOptions, setTitleOptions] = useState(new DDOption() || []);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(null);

    function handleChange(e, actionMeta) {
        setSelectedTitleOption(e);
        onChangeDropdown(e, actionMeta);
    };

    const fetchTitle = async () => {
        try {
            let titleDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/titlelist", {params: titleDetails});
            if (response.status === 200) {
                setTitleDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setTitleDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.TitleId, label: p.Title, name: p.Title, description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setTitleOptions(allModuleOpt);
        setSelectedTitleOption(allModuleOpt.filter(x => x.value === selectedValue));
    }

    const handleCreate = async (inputValue) => {
        
        setIsLoading(true);
        setTimeout(async () => {
            const newOption = await createOption(inputValue);
            setIsLoading(false);
            setTitleOptions((prev) => [...prev, newOption]);
            setSelectedTitleOption(newOption);
            let actionMeta = { name: "TitleId"}
            onChangeDropdown(newOption, actionMeta);
        }, 1000);
    };

    const createOption = async (newTitle) => {
        let titleDetails = {
          TitleId: null,
          Title: newTitle,
          Description: null,
          UserId: getStorageValues('userId'),
        };
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveTitle",
            titleDetails
          );
          if (response.status === 200) {
            if(response.data.data[0].success === 1){
                let newOption = {
                    value: response.data.data[0].TitleId, 
                    label: response.data.data[0].Title,
                    name: response.data.data[0].Title, 
                    description: "", 
                    isFixed: false, 
                    isDisabled: false, 
                    groupId: null
                } 
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                return newOption
            } else {
              CreateAlert(response.data.data[0].message, "Error", setAlert);
            }
          } 
        } catch (error) {
          console.log(error);
        }
        return null;
    }
    useEffect(() => {
        fetchTitle();
    }, []);
    return (
        <>
            <SKAlerts alert={alert} />
            <div className="col-12">
                <div className="mb-3">
                    <label className="form-label">
                        Title { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                    </label>
                    <CreatableSelect
                        isClearable
                        isDisabled={isDisable === false || isDisable === undefined ? isLoading : isDisable}
                        isLoading={isLoading}
                        name={modelName}
                        value={selectedTitleOption ? selectedTitleOption : []}
                        options={getTitleOptions || []}
                        onChange={handleChange}
                        onCreateOption={handleCreate}
                        placeholder ={placeholder ? placeholder : "Select..."}
                    /> 
                </div>
            </div>
        </>
    )
}

export default TitleDropdown